import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class LogPainelService {
  constructor(private readonly http: HttpClient) { }



  async getFilterType(filter): Promise<any> {
    try {
      const url = environment.apiBaseUrl + '/PainelApp/TiposDeFiltro';
  
      const payload = { filtro: filter };
  
      const response = await this.http.post(url, payload).toPromise<any>();
      if (response.success) {
        return response.result;
      } else {
        return response.result.message;
      }
    } catch (error) {
      return error;
    }
  }


  async getAllRegistros(filters): Promise<any> {
    try {
      const url = environment.apiBaseUrl + '/PainelApp/ListarRegistros';

      const response = await this.http.post(url, filters).toPromise<any>();

      if (response.success) {
        return response?.result || [];
      } else {
        return response?.result.message;
      }
    } catch (error) {
      console.error(error);
      return error;
    }
  }
}
